/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Upload_CompleteInputs */



/**
* | output |
* | --- |
* | "Upload complete." |
*
* @param {Ateliere_Connect_Status_Upload_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_upload_complete = /** @type {((inputs?: Ateliere_Connect_Status_Upload_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Upload_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléversement terminé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Upload abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento completato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка завершена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carga completa.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上传完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップロードが完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपलोड पूरा हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Envio concluído.")
	return /** @type {LocalizedString} */ ("Upload complete.")
});